import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Table, TableBody, TableContainer, Typography } from '@mui/material';
import { TableLoader } from '@livable/saas-react-components';
import warningImg from 'src/img/warning.svg';
import RowV2 from '../tableRowV2';
import useStyles from '../styles';
import { useTranslation } from 'react-i18next';
export const ARReportTab = observer(_ref => {
  var _getARReportData;
  let companyReport = _ref.companyReport,
    companyReportTotalUnpaid = _ref.companyReportTotalUnpaid,
    isLoading = _ref.isLoading,
    isDisabled = _ref.isDisabled,
    _ref$propertyOptions = _ref.propertyOptions,
    propertyOptions = _ref$propertyOptions === void 0 ? [] : _ref$propertyOptions,
    getPropertyById = _ref.getPropertyById;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const getARReportData = () => {
    if (!companyReport || !companyReport.length) return;
    const arData = {};
    companyReport.forEach(resident => {
      var _arData$combinedId, _arData$combinedId2, _arData$combinedId3;
      const combinedId = 'AR_Combined_ID';
      const residentItem = _objectSpread(_objectSpread({}, resident), {}, {
        residentFullName: resident.residentFullName,
        total: resident.total,
        currentPeriod: resident.currentPeriod,
        dayMonthPeriod: resident.dayMonthPeriod,
        oneMonthTwoMonthPeriod: resident.oneMonthTwoMonthPeriod,
        twoMonthThreeMonthPeriod: resident.twoMonthThreeMonthPeriod,
        moreThreeMonthPeriod: resident.moreThreeMonthPeriod,
        phone: resident.phone,
        unitName: resident.unitName,
        emailAddress: resident.emailAddress,
        propertyId: resident.propertyId,
        accountId: resident.accountId
      });
      arData[combinedId] = {
        propertyId: resident.propertyId,
        residents: (_arData$combinedId = arData[combinedId]) !== null && _arData$combinedId !== void 0 && _arData$combinedId.residents && (_arData$combinedId2 = arData[combinedId]) !== null && _arData$combinedId2 !== void 0 && (_arData$combinedId2 = _arData$combinedId2.residents) !== null && _arData$combinedId2 !== void 0 && _arData$combinedId2.length ? [...((_arData$combinedId3 = arData[combinedId]) === null || _arData$combinedId3 === void 0 ? void 0 : _arData$combinedId3.residents), residentItem] : [residentItem]
      };
    });
    Object.keys(arData).forEach(key => {
      arData[key] = Object.assign({}, arData[key], getPropertyById(key));
    });
    return Object.entries(arData).map(_ref2 => {
      let _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return /*#__PURE__*/React.createElement(RowV2, {
        key: key,
        data: value,
        getPropertyById: getPropertyById,
        companyReportTotalUnpaid: companyReportTotalUnpaid,
        isDisabled: isDisabled,
        propertyOptions: propertyOptions
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('reimbursement_dashboard.ar_report')), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.tableContainer
  }, isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableBody, null, getARReportData()))), !isLoading && !((_getARReportData = getARReportData()) !== null && _getARReportData !== void 0 && _getARReportData.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholder
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('reimbursement_dashboard.no_data')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "warning image",
    src: warningImg,
    height: "338",
    width: "407"
  })))));
});